import React from 'react';
import { Lock, CheckCircle, Clock, ArrowRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const IdentityDashboard = () => {
  const navigate = useNavigate();

  return (
    <div className="container" style={{ padding: '4rem 0' }}>
      <div style={{ marginBottom: '3rem' }}>
        <h1 className="hero-title" style={{ fontSize: '2.5rem', marginBottom: '0.5rem' }}>Identity Services</h1>
        <p style={{ color: 'var(--gray)' }}>IAM implementation and governance</p>
      </div>

      {/* Implementation Status */}
      <div className="card-emphasis" style={{ marginBottom: '2rem', background: 'rgba(59, 130, 246, 0.05)' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '2rem' }}>
          <div>
            <div className="label" style={{ marginBottom: '0.5rem' }}>Implementation Status</div>
            <h2 style={{ fontSize: '1.5rem', fontWeight: 700, marginBottom: '0.5rem' }}>Awaiting Kickoff</h2>
            <p style={{ color: 'var(--gray)' }}>Our team will contact you within 24 hours</p>
          </div>
          <Clock size={48} style={{ color: 'var(--blue)' }} />
        </div>

        <div style={{ display: 'flex', gap: '1rem' }}>
          <div style={{ flex: 1, padding: '1rem', background: 'var(--white)', borderRadius: '0.5rem' }}>
            <div className="label" style={{ marginBottom: '0.5rem' }}>Next Step</div>
            <p style={{ fontWeight: 600 }}>Schedule kickoff call</p>
          </div>
          <div style={{ flex: 1, padding: '1rem', background: 'var(--white)', borderRadius: '0.5rem' }}>
            <div className="label" style={{ marginBottom: '0.5rem' }}>Expected Timeline</div>
            <p style={{ fontWeight: 600 }}>4-6 weeks</p>
          </div>
        </div>
      </div>

      {/* Implementation Phases */}
      <h2 className="section-title" style={{ marginBottom: '1.5rem' }}>Implementation Roadmap</h2>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem', marginBottom: '3rem' }}>
        {[
          {
            phase: 'Discovery & Selection',
            duration: 'Week 1-2',
            status: 'pending',
            tasks: ['Platform evaluation', 'Requirements gathering', 'Vendor negotiation']
          },
          {
            phase: 'Implementation',
            duration: 'Week 3-8',
            status: 'pending',
            tasks: ['Platform configuration', 'SSO deployment', 'MFA rollout', 'Workflow automation']
          },
          {
            phase: 'Ongoing Governance',
            duration: 'Month 3+',
            status: 'pending',
            tasks: ['Access reviews', 'Policy optimization', 'Compliance reporting']
          }
        ].map((phase, index) => (
          <div key={index} className="card">
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'start' }}>
              <div style={{ flex: 1 }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '0.5rem' }}>
                  <div style={{
                    width: '32px',
                    height: '32px',
                    borderRadius: '50%',
                    background: phase.status === 'completed' ? 'var(--success)' : 'var(--light-gray)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: phase.status === 'completed' ? 'white' : 'var(--gray)',
                    fontWeight: 700
                  }}>
                    {phase.status === 'completed' ? <CheckCircle size={20} /> : index + 1}
                  </div>
                  <h3 className="subsection-title" style={{ marginBottom: 0 }}>{phase.phase}</h3>
                </div>
                <p style={{ fontSize: '0.875rem', color: 'var(--gray)', marginBottom: '1rem', marginLeft: '48px' }}>
                  {phase.duration}
                </p>
                <ul style={{ fontSize: '0.875rem', paddingLeft: '68px', color: 'var(--charcoal)' }}>
                  {phase.tasks.map((task, i) => (
                    <li key={i}>{task}</li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Platform Selection */}
      <h2 className="section-title" style={{ marginBottom: '1.5rem' }}>Selected Platform</h2>
      <div className="card-emphasis" style={{ marginBottom: '2rem' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div>
            <h3 className="subsection-title" style={{ marginBottom: '0.5rem' }}>Platform TBD</h3>
            <p style={{ color: 'var(--gray)' }}>
              Will be determined during discovery phase based on your requirements
            </p>
          </div>
          <Lock size={48} style={{ color: 'var(--blue)' }} />
        </div>
      </div>

      {/* Contact Support */}
      <div className="card" style={{ background: 'var(--light-gray)' }}>
        <h3 className="subsection-title" style={{ marginBottom: '1rem' }}>Need Help?</h3>
        <p style={{ marginBottom: '1.5rem', color: 'var(--charcoal)' }}>
          Our implementation team is here to assist you through every step of the process.
        </p>
        <button className="btn btn-secondary">
          Contact Support
        </button>
      </div>
    </div>
  );
};

export default IdentityDashboard;
